/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  ClusterOutlined,
  ContactsOutlined,
  EnvironmentOutlined,
  ImportOutlined,
  LinkOutlined,
  UploadOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';
import { MenuProps } from 'antd';

import { useCustomTranslation } from '../../../../hooks/custom-translation';
import { useGetInfoQuery } from '../../../../services/auth';
import { useGetCustomerByIdQuery } from '../../../../services/customer/customer-service';
import { AsideContainer, MenuGroup, Title } from './styles';

const SideNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { tSideNav } = useCustomTranslation('sideNav', 'home');
  const { data: info } = useGetInfoQuery();
  const { data: customer } = useGetCustomerByIdQuery(info?.customer || '', {
    skip: !info?.customer,
  });

  const createMenuByRoles = useCallback(() => {
    const type = customer?.customerType ?? null;
    console.log('type', type);
    // Menus PF (ordem e rotas corretas)
    const menuPF = [
      {
        key: '/portal/contact-import-wizard-pf',
        label: 'Enriquecimento de dados PF',
        icon: <UploadOutlined />,
      },
      {
        key: '/portal/database-management-pf',
        label: 'Gestão de bases PF',
        icon: <ImportOutlined />,
      },
      {
        key: '/portal/contact-profile-search',
        label: 'Busca de perfil de contato',
        icon: <ContactsOutlined />,
      },
      {
        key: '/portal/contact-segmentation',
        label: 'Segmentação de contatos',
        icon: <ClusterOutlined />,
      },
      {
        key: '/portal/map',
        label: 'Público potencial',
        icon: <EnvironmentOutlined />,
      },
      {
        key: '/portal/connection_management',
        label: 'Conexão de audiência',
        icon: <LinkOutlined />,
      },
      {
        key: '/portal/personas',
        label: 'Personas',
        icon: <UsergroupAddOutlined />,
      },
    ];

    // Menus PJ (ordem e rotas corretas)
    const menuPJ = [
      {
        key: '/portal/contact-import-wizard-pj',
        label: 'Enriquecimento de dados PJ',
        icon: <UploadOutlined />,
      },
      {
        key: '/portal/database-management-pj',
        label: 'Gestão de bases PJ',
        icon: <ImportOutlined />,
      },
      {
        key: '/portal/contact-profile-search',
        label: 'Busca de perfil de contato',
        icon: <ContactsOutlined />,
      },
      {
        key: '/portal/map',
        label: 'Público potencial',
        icon: <EnvironmentOutlined />,
      },
      {
        key: '/portal/connection_management',
        label: 'Conexão de audiência',
        icon: <LinkOutlined />,
      },
    ];

    if (type === 'PF') {
      return menuPF;
    }
    if (type === 'PJ') {
      console.log('SSSSSSPROCURE ');
      return menuPJ;
    }
    // ... mantenha lógica para outros tipos ...
    return menuPF; // fallback para ambos
  }, [customer]);

  const ITEMS_MENU: MenuProps['items'] = useMemo(
    () => createMenuByRoles(),
    [createMenuByRoles],
  );

  const handleClickItemMenu = useCallback(
    ({ key }: { key: string }) => {
      navigate(key);
    },
    [navigate],
  );

  return (
    <>
      <AsideContainer>
        <Title>{tSideNav('title')}</Title>
        <MenuGroup
          mode="inline"
          items={ITEMS_MENU}
          onSelect={handleClickItemMenu}
          selectedKeys={[location.pathname]} // Define o item selecionado com base no pathname
        />
      </AsideContainer>
    </>
  );
};

export default memo(SideNav);
